import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const STORAGE_KEY = "dc-cookie-notice-v1";

export default function CookieNotice() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60]"
      data-testid="cookie-notice"
    >
      <div className="bg-[#FFD93D] border-2 border-[#0A0A0A] pop-shadow p-5">
        <div className="flex items-start gap-3">
          <Cookie className="w-6 h-6 text-[#0A0A0A] flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF2E63] mb-1">Cookies</div>
            <h2 className="font-heading font-black text-[#0A0A0A] text-lg leading-tight">A quick note.</h2>
            <p className="mt-2 text-sm text-[#0A0A0A] leading-relaxed">
              We use a single <strong>session cookie</strong> to keep you signed in. Embedded YouTube videos on our Films page may set their own cookies when you press play.
              {" "}<Link to="/cookies" data-testid="cookie-notice-cookies-link" className="underline underline-offset-2 hover:text-[#FF2E63]">Cookie policy</Link>
              {" · "}
              <Link to="/privacy" data-testid="cookie-notice-privacy-link" className="underline underline-offset-2 hover:text-[#FF2E63]">Privacy</Link>
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <button
                onClick={dismiss}
                data-testid="cookie-notice-accept"
                className="bg-[#FF2E63] text-[#FFF8E7] hover:bg-[#E0204F] border-2 border-[#0A0A0A] rounded-none px-5 py-2 text-sm font-bold uppercase tracking-[0.12em]"
              >
                Got it
              </button>
              <Link
                to="/cookies"
                data-testid="cookie-notice-more"
                className="text-sm text-[#0A0A0A] underline underline-offset-2 hover:text-[#FF2E63] px-2 py-1"
              >
                Learn more
              </Link>
            </div>
          </div>
          <button
            onClick={dismiss}
            aria-label="Dismiss cookie notice"
            data-testid="cookie-notice-close"
            className="bg-[#0A0A0A] text-[#FFF8E7] hover:bg-[#FF2E63] p-1.5 border-2 border-[#0A0A0A] flex-shrink-0"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
